import React, { useEffect, useRef, useState } from 'react';
import { menuData } from '../data/menu';
import { GoldDivider } from './GoldDivider';
import { MenuCategoryBlock } from './MenuCategoryBlock';
export function MenuSection() {
  const [active, setActive] = useState(menuData[0].id);
  const tabRefs = useRef<Record<string, HTMLAnchorElement | null>>({});
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      const visible = entries.filter(e => e.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
      if (visible[0]) setActive(visible[0].target.id);
    }, {
      rootMargin: '-20% 0px -55% 0px'
    });
    menuData.forEach(c => {
      const el = document.getElementById(c.id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    tabRefs.current[active]?.scrollIntoView({
      block: 'nearest',
      inline: 'center',
      behavior: 'smooth'
    });
  }, [active]);
  return <section id="menu" aria-labelledby="menu-heading" className="w-full bg-night" data-id="element-44" data-mp="3qn1dggvs3m7z">
      <div className="wrap" data-id="element-45" data-mp="3vkuk1b0zui8s">
        <GoldDivider data-id="element-46" data-mp="3vk1lgxc6uz1q" />
      </div>
      <div className="wrap pt-[clamp(3rem,4.5vw,10rem)]" data-id="element-47" data-mp="3vj9szvdw1hfo">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between" data-id="element-48" data-mp="47q9bpzw13j5">
          <h2 id="menu-heading" className="fs-display text-gold-gradient pb-[0.05em] font-display font-bold leading-tight" data-id="element-49" data-mp="94qbvqxj3o5i">
            Menú
          </h2>
          <p className="fs-sm text-muted sm:pb-[0.8em]" data-id="element-50" data-mp="37prsuwepw2p5">Call it in — we'll have it hot at the window.</p>
        </div>
      </div>

      <nav aria-label="Menu categories" className="sticky top-[var(--header-h)] z-40 mt-[clamp(1.5rem,2.2vw,5rem)] border-y border-gold/20 bg-night/95 backdrop-blur" data-id="element-51" data-mp="3hl1vnmcxwe3z">
        <ul className="no-scrollbar wrap flex gap-[clamp(0.5rem,0.6vw,1.5rem)] overflow-x-auto py-[clamp(0.75rem,0.8vw,2rem)]" data-id="element-52" data-mp="wvvrq63gygft">
          {menuData.map(c => {
          const isActive = active === c.id;
          return <li key={c.id} className="shrink-0" data-id="element-53" data-mp="2xwae1gwqm0l2">
                <a ref={el => {
              tabRefs.current[c.id] = el;
            }} href={`#${c.id}`} aria-current={isActive ? 'true' : undefined} className={`fs-nav inline-block whitespace-nowrap rounded-full px-[1.3em] py-[0.7em] font-label font-medium uppercase leading-none tracking-[0.16em] transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-light ${isActive ? 'bg-gold-gradient text-ink' : 'text-muted hover:text-gold-light'}`} data-id="element-54" data-mp="2syhakvmtjkoh">
                  {c.title}
                </a>
              </li>;
        })}
        </ul>
      </nav>

      <div className="wrap flex flex-col gap-[clamp(4rem,6vw,14rem)] py-[clamp(3rem,4vw,10rem)]" data-id="element-55" data-mp="1vhsab6dioqh7">
        {menuData.map(c => <MenuCategoryBlock key={c.id} category={c} data-id="element-56" data-mp="1rfoyuhqullvx" />)}
      </div>
    </section>;
}